import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import { Button } from '../../../../components/buttons';
import { Layout, MinMaxLayout, SeventyThirtyLayout, SixtyFourtyLayout } from '../../../../layouts';
import Welcome from '../../../../layouts/welcome';
import Row from '../../../../components/row';
import Container from '../../../../layouts/containers/container';
import List from '../../../../components/list';
import InputsDropdown from '../../../../components/inputs/inputs-dropdown';
import SearchBar from '../../../../components/searchbar';
import ContainerTable from '../../../../layouts/containers/container-table';
import { getDSTLocalTime, stringToFriendlyDatetime } from '../../../../lib/helpers/datetime-helpers';
import ContainerIndex from '../../../../layouts/containers/container-index';
import Arrow from '../../../../components/buttons/arrow';
import companiesApi from '../../../../lib/companies/companies-api';
import dayjs from 'dayjs';
import CompanyCredits from '../../../../icons/company-credits';
import Stats from '../../../../components/stats';
import { SmallPill } from '../../../../components/pills';
import EmptyState from '../../../../components/states/empty';
import RenderThisIf from '../../../../components/renderIf';

const routes = {
    'App\\Models\\MeetingRoomBooking': '',
    'App\\Models\\CoWorkingBooking': '/co-working'
}

class DebitsIndex extends Component {
    constructor(props) {
        super(props);

        this.state = {
            debits: null,
            usage: {},
            company: null,
            page: 1,
        }
    }

    componentDidMount() {
        this.getCredits();

        companiesApi.getCreditsUsage(window.user.company_id).then(({ data }) => {
            this.setState({ usage: data });
        });

        companiesApi.getCompany(window.user.company_id).then(({ data }) => {
            this.setState({ company: data })
        });
    }

    getCredits() {
        this.setState({ debits: null });

        companiesApi.getCreditDebits(window.user.company_id, {
            per_page: 12,
            page: this.state.page,
        }).then(({ data, meta }) => {
            this.setState({ debits: data, meta: meta });
        })
    }

    render() {
        const creditsThisMonth = this.state.usage?.year?.[dayjs().startOf('month').format('YYYY-MM-DD')];
        const membership = this.state.company?.company_memberships?.[0]?.membership;

        return <ContainerIndex>
            <ContainerIndex.Filters>
                <Row gap="20px" fill>
                    <div className="banner" style={{
                        width: '100%'
                    }}>
                        { membership && !Number.isNaN(Number.parseInt(membership?.credits_per_month - creditsThisMonth)) && <Container className="banner__item banner__credits">
                            <Container.Header>
                                <Row gap="20px" justifyContent="space-between">
                                    <Row gap='10px'>
                                        <Container.Icon src={CompanyCredits}/>
                                        <Container.Text fontSize="20px" color="white" fontWeight='500'>Your Membership Credits</Container.Text>
                                    </Row>
                                </Row>
                            </Container.Header>

                            <Container.Content>
                                <Row gap="40px">
                                    <Stats center valueColor="white" titleColor="#00C8C3" title="Used this month" value={Number.parseInt(membership?.credits_per_month - creditsThisMonth)}/>
                                    <Stats center valueColor="white" titleColor="#00C8C3" title="Remaining (Current Month)" value={creditsThisMonth} />
                                </Row>
                            </Container.Content>
                        </Container> }

                        { this.state.usage?.additional_credits > 0 ? <Container className="banner__item banner--orange">
                            <Container.Header>
                                <Row gap="20px" justifyContent="space-between">
                                    <Row gap='10px'>
                                        <Container.Icon src={CompanyCredits}/>
                                        <Container.Text fontSize="20px" color="white" fontWeight='500'>Additional Credits</Container.Text>
                                    </Row>
                                </Row>
                            </Container.Header>

                            <Container.Content>
                                <Row gap="40px">
                                    <Stats center valueColor="white" titleColor="#00C8C3" title="Remaining" value={this.state.usage?.additional_credits} />
                                </Row>
                            </Container.Content>
                        </Container> : <div className="banner__item"></div> }
                    </div>
                </Row>
            </ContainerIndex.Filters>

            <ContainerIndex.Content grid={false}>
                <SixtyFourtyLayout
                    main={
                        <List gap="40px">
                            <ContainerTable
                                isEmpty={this.state.debits === null || this.state.debits?.length === 0}
                                ifEmpty={
                                    <EmptyState 
                                        loading={this.state.debits === null} 
                                        title="Receipts" 
                                        description="Nothing to see here" 
                                        titleColor="black"
                                        descriptionColor="black"
                                        style={{ minHeight: '300px' }}
                                    />
                                }
                                className="table-bookings"
                                columns={[
                                    { field: 'Debited At', width: '30%' },
                                    { field: 'Amount Debited', width: '20%' },
                                    { field: 'Related To', width: '33%' },
                                    { field: 'View Booking', width: '17%' },
                                ]}
                                data={
                                    this.state.debits?.length > 0 ? this.state.debits?.map((item) => {
                                        let relation = '';

                                        if (item.related_to === 'App\\Models\\MeetingRoomBooking') {
                                            relation = 'Meeting Room Booking';
                                        }
                                        
                                        if (item.related_to === 'App\\Models\\CoWorkingBooking') {
                                            relation = 'Meeting Room Booking';
                                        }

                                        return [
                                            dayjs(item?.debited).format('DD/MM/YYYY - hh:mm'),
                                            item?.amount,
                                            relation,
                                            item,
                                        ]
                                    }) : []
                                }
                                rowStyle={{
                                    backgroundColor: 'white',
                                }}
                                replaceColumn={{
                                    0: (data) => {
                                        return <Container.Text color="#FF6933">{ data }</Container.Text> 
                                    },
                                    3: (data) => {
                                        const route = routes?.[data.related_to];

                                        return (
                                            <svg onClick={() => window.location.href = `/mydmc${route}/bookings/${data?.related_id}`} style={{ cursor: 'pointer', rotate: '-90deg', marginLeft: '40px' }} xmlns="http://www.w3.org/2000/svg" width="17.702" height="18.349" viewBox="0 0 17.702 18.349">
                                                <path id="Path_57" data-name="Path 57" d="M14.211,17.959l6.1-6.151,1.609,1.622-8.851,8.92-8.851-8.92,1.609-1.622,6.1,6.151V4h2.276Z" transform="translate(-4.222 -4)" fill="#cecece"/>
                                            </svg>
                                        )
                                    }
                                }}
                            />

                            <ContainerIndex.Pagination
                                currentPage={this.state.page}
                                maxPages={this.state.meta?.last_page}
                                onNext={() => this.setState({ page: this.state.page + 1 }, () => this.getCredits())}
                                onPrevious={() => this.setState({ page: this.state.page - 1 }, () => this.getCredits())}
                            />
                        </List>
                    }
                    sectionOne={
                        {
                            name: '',
                            component: <ContainerTable
                                className="table-bookings"
                                columns={[
                                    { field: 'Month', width: '50%' },
                                    { field: 'Credits', width: '50%' },
                                ]}
                                data={
                                    Object.keys(this.state.usage?.year || {})?.length > 0 ? Object.keys(this.state.usage?.year)?.map((i) => {
                                        const item = this.state.usage?.year?.[i];

                                        return [
                                            getDSTLocalTime(i).format('MMMM'),
                                            item,
                                        ]
                                    }) : []
                                }
                                rowStyle={{
                                    backgroundColor: 'white',
                                }}
                               
                            />
                            }
                        }
                    />
            </ContainerIndex.Content>
        </ContainerIndex>
    }
}

const el = document.getElementById('account-memberships-debits');

if (el) {
    ReactDOM.render(
        <Layout 
            theme="dark"
            topLeft={<Welcome title="Welcome to your" subtitle="Debits"/>}
            topRight={
                <Row gap="20px">
                    
                </Row>
            }
        >
            <MinMaxLayout
                main={<DebitsIndex/>}
            />
        </Layout>    
    , el);
}
